/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Custom_Properties_Tab_ColorInputs */

const en_tables_custom_properties_tab_color = /** @type {(inputs: Tables_Custom_Properties_Tab_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Properties Tab Color`)
};

const de_tables_custom_properties_tab_color = /** @type {(inputs: Tables_Custom_Properties_Tab_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tab Farbe`)
};

/**
* | output |
* | --- |
* | "Properties Tab Color" |
*
* @param {Tables_Custom_Properties_Tab_ColorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_custom_properties_tab_color = /** @type {((inputs?: Tables_Custom_Properties_Tab_ColorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Custom_Properties_Tab_ColorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_custom_properties_tab_color(inputs)
	return de_tables_custom_properties_tab_color(inputs)
});